import { render } from "./Volunteer.vue?vue&type=template&id=ec775038&scoped=true"
import script from "./Volunteer.vue?vue&type=script&lang=js"
export * from "./Volunteer.vue?vue&type=script&lang=js"

import "./Volunteer.vue?vue&type=style&index=0&id=ec775038&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec775038"]])

export default __exports__